import axios from "axios";
import queryString from "query-string";
import React, {useEffect, useState} from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useLocation, useNavigate, useParams } from "react-router";
import ProfileMain from "./profile/ProfileMain";
import DefaultLoader from "../components/loader/DefaultLoader";
import NextSeriesMain from "./profile/NextSeriesMain";
import RecentGameMain from "./profile/RecentGameMain";
import SeriesMain from "./series/SeriesMain";
import TrackmanChartMain from "./record/TrackmanChartMain";
import PitchLocationMain from "./record/PitchLocationMain";
import DamageChartMain from "./record/DamageChartMain";
import RecordTableMain from "./record/RecordTableMain";
import {useCookies} from 'react-cookie';
import PitchDistributionChartMain from "./record/PitchDistributionChartMain";
import Header from "../components/header/Header";
import SearchBar from "../components/searchBar/SearchBar";
import MovingChartMain from "./record/MovingChartMain";
import { intervalLogging, stopLogging} from '../components/common/Logger';
import SprayChartMain from "./record/SprayChartMain";
import ProfileImage from "./profile/ProfileImage";

function PitcherPage() {
    const [cookies] = useCookies(['hiball_token']);
    const navigate = useNavigate();
    const location = useLocation();
    let [profile, setProfile] = useState({
        playerId: null, teamId: null, type: null,
        birthdate: null
    });

    const { playerId } = useParams();

    useEffect(() => {
        const season = new Date().getFullYear();
        let playerObj = {
            playerType: 'pitcher',
            playerId
        }
        stopLogging();
        intervalLogging(location.pathname, cookies['hiball_token'], playerObj);
        axios({
            url : `${process.env.REACT_APP_API_URL}`,
            params: {
                recordType: 'digestRecord', recordName: 'selectProfile',
                pitcherIds: playerId,
                seasons: season,
                authToken:JSON.stringify(cookies['hiball_token'])
            }
        }).then((result) => {
            if(result.data.result.length < 1) {
                navigate('/');
            } else {
                setProfile({
                    playerId: playerId,
                    teamId: result['data']['result'][0]['pitcher']['pitcherTeamId'],
                    type: 'pitcher',
                    birthdate: result['data']['result'][0]['pitcher']['birthdate']
                });
            }
        });
    }, []);

    const style={
        height: '450px',
        display: 'flex',
        flexDirection: 'column'
    }

    return (
        <>
        <Header title={'투수'}/>
        <Container fluid="xl" className="container">
            <Row>
                <SearchBar/>
            </Row>
            <Row>
                <Col md={3} className="digestDivBox" id="playerImage">
                    {
                        profile['teamId'] ? 
                        <ProfileImage profile={profile}/> :
                        <div style={{...style, ...{height:'390px'}}}>
                            <DefaultLoader/>
                        </div>
                    }
                </Col>
                <Col className="digestDivBox" id="playerProfile">
                    {
                        profile['teamId'] ?
                        <ProfileMain profile={profile}/> :
                        <div style={{...style, ...{height:'390px'}}}>
                            <DefaultLoader/>
                        </div>
                    }
                </Col>
            </Row>
            <Row>
                <Col md={3} id="last10games" className="digestDivBox">
                    {
                        profile['teamId'] ?
                        <RecentGameMain profile={profile}/> :
                        <div style={{...style, ...{height:'390px'}}}>
                            <DefaultLoader/>
                        </div>
                    }
                </Col>
                <Col id="chartZone2" className="digestDivBox" style={{position:'relative'}}>
                    <div style={style}>
                        {
                            profile['teamId'] ?
                            <SprayChartMain profile={profile} /> :
                            <DefaultLoader/>
                        }
                    </div>
                </Col>
                {/* <Col id="gameSchedule" className="digestDivBox">
                    {
                        profile['teamId'] ?
                        <NextSeriesMain profile={profile}/> :
                        <div style={{...style, ...{height:'390px'}}}>
                            <DefaultLoader/>
                        </div>
                    }
                </Col> */}
            </Row>
            <Row>
                {
                    profile['teamId'] ?
                    <SeriesMain profile={profile}/> :
                    <Col md={12}>
                        <div style={{height: '300px'}}>
                            <DefaultLoader />
                        </div>
                    </Col>
                }
            </Row>
            {/* <Row>
                <Col id="chartZone1" className="digestDivBox" style={{position:'relative', height: '500px'}}>
                    <div style={{...style, ...{textAlign:'center'}}}>
                    {
                        profile['teamId'] ?
                        <PitchDistributionChartMain profile={profile} /> :
                        <DefaultLoader/>
                    }
                    </div>
                </Col>
                <Col id="chartZone2" className="digestDivBox" style={{position:'relative', height: '500px'}}>
                    <div style={style}>
                    {
                        profile['teamId'] ?
                        <TrackmanChartMain profile={profile} /> :
                        <DefaultLoader/>
                    }
                    </div>
                </Col>
            </Row> */}
            {/* <Row>
                <Col id="movingChartZone" className="digestDivBox" style={{position:'relative'}}>
                    {
                        profile['teamId'] ?
                        <MovingChartMain profile={profile} /> :
                        <DefaultLoader/>
                    }
                </Col>
            </Row>
            <Row>
            {
                profile['teamId'] ?
                <DamageChartMain profile={profile} /> :
                <Col md={12}>
                    <div style={{height: '100px'}}>
                        <DefaultLoader/>
                    </div>
                </Col>
            }
            {
                profile['teamId'] ?
                <PitchLocationMain profile={profile} /> :
                <Col md={12}>
                    <div style={{height: '100px'}}>
                        <DefaultLoader/>
                    </div>
                </Col>
            }
            </Row>
            <Row>
                <div id="tableContainer">
                {
                    profile['teamId'] ?
                    <RecordTableMain profile={profile}/> :
                    <div style={{height: '200px'}}>
                        <DefaultLoader/>
                    </div>
                }
                </div>
            </Row> */}
        </Container>
        </>
    )
}

export default PitcherPage;